import React from 'react';
import './index.css';
import { Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Contact from './pages/Contact';
import TrainingWorkShops from './pages/Training&WorkShops';
import OurTeamPage from './pages/OurTeam';
import TraumaPage from './pages/Trauma';
import About from './pages/About';
import Blogs from './pages/Blogs';
import Layout from './layout/Layout';
import ServiceTemplatePage from './pages/ServiceTemplatePage';
import RelationshipConcernsPage from './pages/RelationshipPage';
import AbusePage from './pages/AbusePage';
import GenderBasedViolencePage from './pages/ViolencePage';
import GenderSexualIdentityPage from './pages/QueerPage';
import BlogTemplate from './components/utilities/BlogTemplate';
import GroupPracticePage from './pages/GroupPracticePage';
import JoinUsPage from './pages/JoinUsPage';
import BookAppointment from './pages/BookAppointment';
import TherapistProfile from './pages/TherapistProfile';
import RoleTemplate from './pages/RoleTemplate';
import TherapistNearMe from './pages/TherapistNearMe';
import PsychologistNearMe from './pages/PsychologistNearMe';
import NewDelhiPage from './pages/NewDelhiPage';
import KamlaNagarPage from './pages/KamlaNagarPage';
import UttamNagarPage from './pages/UttamNagarPage';
import LajpatNagarPage from './pages/LajpatNagarPage';
import OldRajendraNagarPage from './pages/OldRajendraNagar';
import PusaInstitute from './pages/PusaInstPage';
import ShastriNagar from './pages/ShastriNagar';
import KarolBaghPage from './pages/KarolBaghPage';
import PitamPuraPage from './pages/PitamPuraPage';
import DelhiPage from './pages/DelhiPage';
import PatelNagarPage from './pages/PatelNagarPage';
import TitcPage from './pages/TITC';
//import RegistrationPage from './pages/Registration';

export const useScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

}

const App: React.FC = () => {
  useScrollToTop();
  return (
    <Layout>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/trauma' element={<TraumaPage />} />
        <Route path='/relationship-concerns' element={<RelationshipConcernsPage />} />
        <Route path='/abuse' element={<AbusePage />} />
        <Route path="/services/:slug" element={<ServiceTemplatePage />} />
        <Route path='/gender-based-violence' element={<GenderBasedViolencePage />} />
        <Route path='/gender-sexual-identity' element={<GenderSexualIdentityPage />} />
        <Route path='/our-team' element={<OurTeamPage />} />
        <Route path='/roles/:id' element={<RoleTemplate />} />
        <Route path='/training&workshops' element={<TrainingWorkShops />} />
        <Route path='/blogs' element={<Blogs />} />
        <Route path='/blog/:slug' element={<BlogTemplate />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/join-us' element={<JoinUsPage />} />
        <Route path='/therapist/:id' element={<TherapistProfile />} />
        <Route path='/book-appointment' element={<BookAppointment />} />
        <Route path='/group-practice' element={<GroupPracticePage />} />
        <Route path='/courses-at-grehpravesh-1' element={<TitcPage />} />
        {/* <Route path='/registration' element={<RegistrationPage />} /> */}

        {/* location pages */}
        <Route path='/therapist-near-me' element={<TherapistNearMe />} />
        <Route path='/psychologist-near-me' element={<PsychologistNearMe />} />
        <Route path='/best-psychologist-in-new-delhi' element={<NewDelhiPage />} />
        <Route path='/best-psychologist-in-delhi' element={<DelhiPage />} />
        <Route path='/best-psychologist-in-patel-nagar' element={<PatelNagarPage />} />
        <Route path='/best-psychologist-in-kamla-nagar' element={<KamlaNagarPage />} />
        <Route path='/best-psychologist-in-uttam-nagar' element={<UttamNagarPage />} />
        <Route path='/best-psychologist-in-lajpat-nagar' element={<LajpatNagarPage />} />
        <Route path='/best-psychologist-in-old-rajendra-nagar' element={<OldRajendraNagarPage />} />
        <Route path='/best-psychologist-in-pusa-institute' element={<PusaInstitute />} />
        <Route path='/best-psychologist-in-shastri-nagar' element={<ShastriNagar />} />
        <Route path='/best-psychologist-in-karol-bagh' element={<KarolBaghPage />} />
        <Route path='/best-psychologist-in-pitampura' element={<PitamPuraPage />} />
      </Routes>
    </Layout>
  )
}

export default App;